<nav aria-label="Page navigation" *ngIf="shouldShowPaginator" [ngClass]="paginatorContainerClass">
    <ul class="pagination">
     <!-- Previous Page Link -->
    <li class="page-item" [ngClass]="liClass">
        <a class="page-link"
           [ngClass]="[linkClass, currentPage === 1 ? 'disabled' : '']"
           [style.pointer-events]="currentPage === 1 ? 'none' : 'auto'"
           
           (click)="currentPage !== 1 ? changePage(currentPage - 1) : $event.preventDefault()">«</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [ngClass]="[liClass, page === currentPage ? activeLiClass : '']">
       
        <a class="page-link"
        [style.pointer-events]="page === -1 ? 'none' : 'auto'"
   
        (click)="page !== -1 && page !== currentPage ? changePage(page) : $event.preventDefault()">
       {{ page !== -1 ? page : '...' }}
     </a>
      </li>
    
      <!-- Next Page Link -->
      <li class="page-item" [ngClass]="liClass">
        <a class="page-link"
           [ngClass]="[linkClass, currentPage === pageCount ? 'disabled' : '']"
           [style.pointer-events]="currentPage === pageCount ? 'none' : 'auto'"
           
           (click)="currentPage !== pageCount ? changePage(currentPage + 1) : $event.preventDefault()">»</a>
      </li>
    </ul>
  </nav>
  